import React, { useMemo } from 'react';
import classnames from 'classnames';

import { FormProgress } from 'components/Progress';

import Avatar from 'components/Form/Avatar';
import Thumbnail from 'components/Form/Thumbnail';
import Input from 'components/Form/Input';
import Select from 'components/Form/Select';
import Checkbox from 'components/Form/Checkbox';
import Datepicker from 'components/Form/Datepicker';
import Datetime from 'components/Form/Datetime';
import Submit from 'components/Form/Submit';
import Tags from 'components/Form/Tags';
import Type from 'components/Form/Type';
import Save from 'components/Form/Save';

export {
	Avatar,
	Thumbnail,
	Input,
	Select,
	Checkbox,
	Datepicker,
	Datetime,
	Submit,
	Tags,
	Type,
	Save
};

// props:
// @handleSubmit: function | calls parents submit action
// @className: string | additional classes
// @progress: boolean | toggles loading overlay
// @children: object | react objects
export const Form = ({
	withBackground,
	withMarginTop,
	withMarginBottom,
	withPaddingAll,
	withAnimation,
	fixedWidth,
	className,
	progress,
	children,
	onSubmit
}) => {
	// Concat className with modifiers
	const cls = useMemo(() => classnames(
		'form',
		withAnimation && 'withAnimation',
		withBackground && 'withBackground',
		withMarginTop && 'withMarginTop',
		withMarginBottom && 'withMarginBottom',
		withPaddingAll && 'withPaddingAll',
		fixedWidth && 'form--fixedWidth',
		className
	), [
		withAnimation,
		withBackground,
		withMarginTop,
		withMarginBottom,
		withPaddingAll,
		fixedWidth,
		className
	]);

	return (
		<form
			className={cls}
			onSubmit={onSubmit}
		>
			<FormProgress progress={progress} />

			{children}
		</form>
	);
};
